import DEFAULT_INVALID_DOMAINS from 'App/enum/invalidDomains';

// The list itself lives in App/enum/invalidDomains — this file only keeps it reachable through the
// Angular injector for services/templateParser.js, its last consumer. Deleting it is WEB-8881.

angular.module('upsalesApp').constant('DEFAULT_INVALID_DOMAINS', DEFAULT_INVALID_DOMAINS);
